import { useEffect } from "react";
import useLogout from "src/hooks/useLogout";
import { useAppSelector } from "src/redux/redux-hooks";
import userSocket from "./userSocket";

const useAutoLogoutSocket = () => {
  const { handleLogout } = useLogout();
  const { isLoggedIn } = useAppSelector((state) => state.user);
  const { userSocketConnected } = useAppSelector((state) => state.socket);

  useEffect(() => {
    if (userSocketConnected && isLoggedIn) {
      userSocket.logoutUser(() => handleLogout());
      userSocket.userError(() => handleLogout());

      return () => {
        console.log("RM EVENT");
        userSocket.offEvent("admin-log-out");
        userSocket.offEvent("admin-error");
      };
    }
  }, [userSocketConnected, isLoggedIn]);

  return null;
};

export default useAutoLogoutSocket;
